import { Center, VStack, useBreakpointValue } from "native-base";
import React, { useEffect, useRef } from "react";
import { ScrollView } from "react-native";

import MobileHeader from "@/components/molecules/MobileHeader";
import SimpleWebHeader from "@/components/molecules/SimpleWebHeader";
import Container from "@/components/organisms/Container";
import { useViewport } from "@/contexts/ViewportContext";

import CodeForm from "./components/CodeForm";
import EmailForm from "./components/EmailForm";
import RecoveryPassword from "./components/RecoveryPasswordForm";
import { RecoveryPassFormScreenProps } from "./types";

const RecoveryPasswordWeb = ({
  currentStep,
  errors,
  onBack,
  onCancel,
  onSubmitCode,
  onSubmitEmail,
  onSubmitPassword,
  onHaveCodePress,
  isSubmitingCode,
  isSubmitingEmail,
  isSubmitingPassword,
}: RecoveryPassFormScreenProps) => {
  const responsiveWidth = useBreakpointValue({
    base: 2,
    xl: 2.5,
    "2xl": 3.5,
  });

  const { width: windowWidth, isWebMode } = useViewport();
  const width = isWebMode ? windowWidth / responsiveWidth : windowWidth;
  const maxWidth = width * 3;

  const scrollRef = useRef<ScrollView>();

  useEffect(() => {
    scrollRef?.current?.scrollTo({
      x: width * currentStep,
      animated: true,
    });
  }, [currentStep]);

  return (
    <Container Header={<SimpleWebHeader />}>
      <Center h="full">
        <ScrollView
          ref={scrollRef}
          horizontal
          showsHorizontalScrollIndicator={false}
          scrollEnabled={false}
          style={{ width, maxWidth }}>
          <VStack w={width + "px"} p="4" space="8">
            <MobileHeader
              title="Recuperar Senha"
              showLogo={false}
              mt="8"
              shadow="none"
              onBackPress={onBack}
            />
            <EmailForm
              onCancel={onCancel}
              onSubmit={onSubmitEmail}
              onHaveCodePress={onHaveCodePress}
              apiError={errors.email}
              isSubmiting={isSubmitingEmail}
            />
          </VStack>
          <VStack w={width + "px"} p="4" space="8">
            <MobileHeader
              title="Insira o Código"
              showLogo={false}
              mt="8"
              shadow="none"
              onBackPress={onBack}
            />
            <CodeForm
              onCancel={onCancel}
              onSubmit={onSubmitCode}
              apiError={errors.code}
              isSubmiting={isSubmitingCode}
            />
          </VStack>
          <VStack w={width + "px"} p="4" space="8">
            <MobileHeader
              title="Nova Senha"
              showLogo={false}
              mt="8"
              shadow="none"
              onBackPress={onBack}
            />
            <RecoveryPassword
              onCancel={onCancel}
              onSubmit={onSubmitPassword}
              apiError={errors.password}
              isSubmiting={isSubmitingPassword}
            />
          </VStack>
        </ScrollView>
      </Center>
    </Container>
  );
};

export default RecoveryPasswordWeb;
